import createVueApp from '@phoenix/createVueApp';
import ClusterSlider from '@maison/components/organisms/slider/ClusterSlider.vue';

document.querySelectorAll('.phoenix-cluster-slider').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ClusterSlider', ClusterSlider);
  app.mount(el);
});
